import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { decryptData, encryptData, queryStringToJSON } from "utils/encryption";


// Create an Axios instance with base URL
export const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Retrieve token from localStorage
export const getToken = () => localStorage.getItem("solar_web_token") || null;
// remove token from localStorage
export const removeToken = () => localStorage.removeItem("solar_web_token") || null;

// Store token in localStorage
export const setToken = (token) => {
  if (token) localStorage.setItem("solar_web_token", token);
};

// Set Authorization header
export const setJwtToken = () => {
  const token = getToken();
  if (!token) {
    console.error("Token is missing or invalid");
    return {};
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};
// Set headers for multipart requests
export const setMultiPartHeader = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    },
  };
};


// Axios interceptor for handling responses and errors
export const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const resInterceptor = (response) => {
      // console.log('response in axios', response)
      const finalResponse = decryptData(response.data) || {};
      if (
        finalResponse.status === 401 ||
        finalResponse.status === 419 ||
        finalResponse.status === 403
      ) {
        removeToken()
        navigate("/");
      }
      return finalResponse;
    };

    const errInterceptor = (error) => {
      // console.log('error errInterceptor', error?.response?.data)
      const errorRes = decryptData(error?.response?.data)
      if (errorRes.status == 403 || errorRes.status == 401) {
        removeToken()
        navigate("/");
      }
      return errorRes || error;
    };

    instance.interceptors.request.use(function (config) {
      config.transformRequest = [
        function (data = {}, headers) {
          let localData = data;
          if (["get", "delete"].includes(config.method)) {
            const params = config.url?.split("?")[1];
            localData = {
              reqData: encryptData({
                ...queryStringToJSON(params),
                token: getToken(),
              }),
            };
            config.params = localData;
            config.url = config.url?.split("?")[0];
            // console.log('localData', localData)
            return null;
          }

          if (["post", "put", "patch"].includes(config.method)) {
            if (headers["Content-Type"] === "multipart/form-data") {
              const formEntries = [...localData.entries()];
              const formData = new FormData();
              let textObj = {};

              formEntries.forEach(([key, value]) => {
                if (typeof value === "object") {
                  formData.append(key, value);
                } else {
                  textObj[key] = value;
                }
              });
              formData.append(
                "reqData",
                encryptData({
                  ...textObj,
                  token: getToken() || textObj?.token,
                })
              );
              return formData;
            } else {
              localData = {
                reqData: encryptData({
                  ...data,
                  token: getToken() || data?.token,
                }),
              };

              // console.log(localData)
            }
          }

          return JSON.stringify(localData);
        },
      ];
      // config.headers.Authorization = isLoggedIn()
      //   ? "Bearer " + isLoggedIn()
      //   : "";

      return config;
    });

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsSet(true);

    return () => instance.interceptors.response.eject(interceptor);
    // eslint-disable-next-line
  }, []);
  return isSet && children;
};